import { TrackActionsServiceBase } from './track-actions-service-base';

class PayflowTrackActionsService extends TrackActionsServiceBase {
  public payflowPlanSelected({
    planName,
    contacts,
    prepayValue,
    nonProfit,
    fromComparisonTable,
  }: {
    planName: string;
    contacts: number;
    prepayValue: string;
    nonProfit: boolean;
    fromComparisonTable: boolean;
  }) {
    return this.ga4Track(
      `plan-select-${planName}>contacts-${contacts}>prepay-${prepayValue}month>nonprofit-${nonProfit ? 'yes' : 'no'}${
        fromComparisonTable ? '>from-comparison-table' : ''
      }`
    );
  }

  public addOnSelected(addOnId: string) {
    return this.ga4Track(`add add-on - ${addOnId}`);
  }

  public addOnRemoved(addOnId: string) {
    return this.ga4Track(`remove add-on - ${addOnId}`);
  }

  public smsBundleRemoved(page: 'plan-selection' | 'checkout') {
    return this.ga4Track(`sms-bundle-removed>${page}`);
  }

  public prepaySelected(prepayValue: string) {
    return this.ga4Track(`prepay-select-${prepayValue}`);
  }

  public currencySelected(currency: string) {
    return this.ga4Track(`currency-select-${currency}`);
  }

  public nonProfitSelected(nonProfit: boolean) {
    return this.ga4Track(`nonprofit-select-${nonProfit ? 'yes' : 'no'}`);
  }

  public contactsAmountSelected(contacts: number) {
    return this.ga4Track(`contacts-set>${contacts}`);
  }

  public discountCodeApplied() {
    return this.ga4Track(`discount-code-applied`);
  }

  public discountCodeRemoved() {
    return this.ga4Track(`discount-code-removed`);
  }

  // customer payflow
  public submitUpgrade() {
    return this.ga4Track('submit upgrade');
  }

  public upgradeSuccess() {
    return this.ga4Track('upgrade success');
  }

  public upgradeError() {
    return this.ga4Track('upgrade processing error');
  }

  // trialer payflow
  public submitPayment() {
    return this.ga4Track('submit payment');
  }

  public paymentSuccess() {
    return this.ga4Track('payment success');
  }

  public paymentError() {
    return this.ga4Track('payment processing error');
  }

  // rest
  public thankYouPageXeroPartnerButtonClicked() {
    return this.ga4Track('Payflow - Confirmation page - Xero partner button clicked');
  }

  public goingToCheckoutWithXeroAddonSelected() {
    return this.tealiumTrack('click', 'xero', 'Selected Xero Offer in Payflow');
  }

  // mWeb value-focused plan selection (GA4 action prefix retained for dashboard continuity)
  public contactTierSelected(contactTier: string) {
    return this.ga4Track(`IM-3458 | Contact tier selected: ${contactTier}`);
  }

  public prepayToggled(prepayValue: string) {
    return this.ga4Track(`IM-3458 | Prepay toggled: ${prepayValue}`);
  }

  public planTileCtaClicked(planName: string) {
    return this.ga4Track(`IM-3458 | Plan tile CTA clicked: ${planName}`);
  }

  public bounce() {
    return this.ga4Track(`IM-3458 | Bounce`);
  }

  public viewAllFeaturesExpanded() {
    return this.ga4Track(`IM-3458 | View all features expanded`);
  }

  public viewAllFeaturesCollapsed() {
    return this.ga4Track(`IM-3458 | View all features collapsed`);
  }

  public comparisonTableScrollDepth(featureName: string) {
    return this.ga4Track(`IM-3458 | Comparison table scroll depth: ${featureName}`);
  }
}

export const payflowTrackActionsService = new PayflowTrackActionsService();
